function convertYMDtoDMY(dateStr) {
  if (!dateStr) return '';

  // Если уже в формате DD.MM.YYYY, возвращаем как есть
  if (/^\d{2}\.\d{2}\.\d{4}/.test(dateStr)) {
    return dateStr;
  }

  // Если пустая строка или null
  if (typeof dateStr !== 'string') dateStr = String(dateStr);

  // Ожидаем формат YYYY-MM-DD
  const parts = dateStr.split('-');

  if (parts.length !== 3) return dateStr;

  const year = parts[0];
  const month = parts[1];
  const day = parts[2];

  // Проверяем, что год 4-значный (формат YYYY)
  if (year.length !== 4) return dateStr;

  // Валидация даты
  const d = new Date(`${year}-${month}-${day}`);
  if (isNaN(d.getTime())) return dateStr;

  // Форматируем с ведущими нулями
  const formattedDay = day.padStart(2, '0');
  const formattedMonth = month.padStart(2, '0');

  return `${formattedDay}.${formattedMonth}.${year}`;
}

function convertDMYtoYMD(dateStr) {
  if (!dateStr) return '';

  // Если уже в ISO формате, возвращаем
  if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
    return dateStr.substring(0, 10).replace(/-/g, '.');
  }

  // Заменяем разделители на точки для единообразия
  let normalized = dateStr.replace(/-/g, '.');
  const parts = normalized.split('.');

  if (parts.length !== 3) return dateStr;

  // Определяем формат: DD.MM.YYYY или MM.DD.YYYY
  // По умолчанию считаем DD.MM.YYYY
  let day, month, year;

  if (parts[0].length === 4) {
    // YYYY.MM.DD
    year = parts[0];
    month = parts[1].padStart(2, '0');
    day = parts[2].padStart(2, '0');
  } else if (parts[2].length === 4) {
    // DD.MM.YYYY
    day = parts[0].padStart(2, '0');
    month = parts[1].padStart(2, '0');
    year = parts[2];
  } else {
    return dateStr;
  }

  // Валидация
  const d = new Date(`${year}-${month}-${day}`);
  if (isNaN(d.getTime())) return dateStr;

  return `${year}-${month}-${day}`;
}

function convertCountryCodeToCountry(code) {
  const country =
  {
    'RU': 'Россия',
    'UA': 'Украина',
    'KZ': 'Казахстан',
    'AU': 'Австралия',
    'AT': 'Австрия',
    'AZ': 'Азербайджан',
    'AX': 'Аландские острова',
    'AL': 'Албания',
    'DZ': 'Алжир',
    'VI': 'Американские Виргинские острова',
    'AS': 'Американское Самоа',
    'AO': 'Ангола',
    'AI': 'Ангуилла',
    'AD': 'Андорра',
    'AQ': 'Антарктика',
    'AG': 'Антигуа и Барбуда',
    'AR': 'Аргентина',
    'AM': 'Армения',
    'AW': 'Аруба',
    'AF': 'Афганистан',
    'BS': 'Багамские острова',
    'BD': 'Бангладеш',
    'BB': 'Барбадос',
    'BH': 'Бахрейн',
    'BY': 'Беларусь',
    'BZ': 'Белиз',
    'BE': 'Бельгия',
    'BJ': 'Бенин',
    'BM': 'Бермудские Острова',
    'BG': 'Болгария',
    'BO': 'Боливия',
    'BA': 'Босния и Герцеговина',
    'BW': 'Ботсвана',
    'BR': 'Бразилия',
    'BQ': 'Британская антарктическая территория',
    'IO': 'Британская территория в Индийском океане',
    'VG': 'Британские Виргинские Острова',
    'BN': 'Бруней Даруссалам',
    'BF': 'Буркина Фасо',
    'BI': 'Бурунди',
    'BT': 'Бутан',
    'VU': 'Вануату',
    'VA': 'Ватикан',
    'GB': 'Великобритания',
    'HU': 'Венгрия',
    'VE': 'Венесуэла',
    'UM': 'Внешние малые острова (США)',
    'TL': 'Восточный Тимор',
    'VN': 'Вьетнам',
    'GA': 'Габон',
    'HT': 'Гаити',
    'GY': 'Гайана',
    'GM': 'Гамбия',
    'GH': 'Гана',
    'GP': 'Гваделупа',
    'GT': 'Гватемала',
    'GN': 'Гвинея',
    'GW': 'Гвинея-Биссау',
    'DE': 'Германия',
    'DD': 'Германская Демократическая Республика',
    'GG': 'Гернси',
    'GI': 'Гибралтар',
    'HN': 'Гондурас',
    'HK': 'Гонконг, Особый Административный Район Китая',
    'LY': 'Государство Ливия',
    'GD': 'Гренада',
    'GL': 'Гренландия',
    'GR': 'Греция',
    'GE': 'Грузия',
    'GU': 'Гуам',
    'DK': 'Дания',
    'VD': 'Демократическая Республика Вьетнам',
    'CD': 'Демократическая Республика Конго',
    'JE': 'Джерси',
    'DJ': 'Джибути',
    'DO': 'Доминиканская Республика',
    'EG': 'Египет',
    'ZM': 'Замбия',
    'EH': 'Западная Сахара',
    'NQ': 'Земля Королевы Мод',
    'ZW': 'Зимбабве',
    'PZ': 'Зона Панамского канала',
    'IL': 'Израиль',
    'IN': 'Индия',
    'ID': 'Индонезия',
    'JO': 'Иордания',
    'IQ': 'Ирак',
    'IE': 'Ирландия',
    'IR': 'Исламская Республика Иран',
    'IS': 'Исландия',
    'ES': 'Испания',
    'IT': 'Италия',
    'YE': 'Йемен',
    'KY': 'Каймановы острова',
    'KH': 'Камбоджа',
    'CM': 'Камерун',
    'CA': 'Канада',
    'CT': 'Кантон и Эндербери',
    'QA': 'Катар',
    'KE': 'Кения',
    'CY': 'Кипр',
    'KI': 'Кирибати',
    'CN': 'Китай',
    'CC': 'Кокосовые острова',
    'CO': 'Колумбия',
    'KM': 'Коморские Острова',
    'CG': 'Конго',
    'KP': 'Корейская Народно-Демократическая Республика',
    'CR': 'Коста-Рика',
    'CI': 'Кот д’Ивуар',
    'CU': 'Куба',
    'KW': 'Кувейт',
    'KG': 'Кыргызстан',
    'CW': 'Кюрасао',
    'LA': 'Лаосская Народно-Демократическая Республика',
    'LV': 'Латвия',
    'LS': 'Лесото',
    'LR': 'Либерия',
    'LB': 'Ливан',
    'LT': 'Литва',
    'LI': 'Лихтенштейн',
    'LU': 'Люксембург',
    'MU': 'Маврикий',
    'MR': 'Мавритания',
    'MG': 'Мадагаскар',
    'YT': 'Майотта',
    'MO': 'Макао (особый административный район КНР)',
    'MW': 'Малави',
    'MY': 'Малайзия',
    'ML': 'Мали',
    'MV': 'Мальдивы',
    'MT': 'Мальта',
    'MA': 'Марокко',
    'MQ': 'Мартиник',
    'MH': 'Маршалловы Острова',
    'MX': 'Мексика',
    'FX': 'Метрополия Франции',
    'MZ': 'Мозамбик',
    'MC': 'Монако',
    'MN': 'Монголия',
    'MS': 'Монсеррат',
    'MM': 'Мьянма',
    'NA': 'Намибия',
    'YD': 'Народная Демократическая Республика Йемен',
    'NR': 'Науру',
    'ZZ': 'Неизвестный или недействительный регион',
    'NT': 'Нейтральная территория',
    'NP': 'Непал',
    'NE': 'Нигер',
    'NG': 'Нигерия',
    'AN': 'Нидерландские Антильские острова',
    'NL': 'Нидерланды',
    'NI': 'Никарагуа',
    'NU': 'Ниуе',
    'NZ': 'Новая Зеландия',
    'NC': 'Новая Каледония',
    'NO': 'Норвегия',
    'AE': 'Объединенные Арабские Эмираты',
    'PU': 'Объединенные государства Карибских островов',
    'OM': 'Оман',
    'BV': 'Остров Буве',
    'JT': 'Остров Джонстон',
    'DM': 'Остров Доминика',
    'MI': 'Остров Мидуэй',
    'IM': 'Остров Мэн',
    'NF': 'Остров Норфолк',
    'CX': 'Остров Рождества',
    'BL': 'Остров Святого Бартоломея',
    'MF': 'Остров Святого Мартина',
    'SH': 'Остров Святой Елены',
    'WK': 'Остров Уэйк',
    'CV': 'Острова Зеленого Мыса',
    'CK': 'Острова Кука',
    'TC': 'Острова Тёркс и Кайкос',
    'HM': 'Острова Херд и Макдональд',
    'PK': 'Пакистан',
    'PW': 'Палау',
    'PS': 'Палестинская автономия',
    'PA': 'Панама',
    'PG': 'Папуа-Новая Гвинея',
    'PY': 'Парагвай',
    'PE': 'Перу',
    'PN': 'Питкерн',
    'PC': 'Подопечная территория Тихоокеанские острова',
    'PL': 'Польша',
    'PT': 'Португалия',
    'PR': 'Пуэрто-Рико',
    'KR': 'Республика Корея',
    'MK': 'Республика Македония',
    'MD': 'Республика Молдова',
    'RE': 'Реюньон',
    'RW': 'Руанда',
    'RO': 'Румыния',
    'US': 'США',
    'SV': 'Сальвадор',
    'WS': 'Самоа',
    'SM': 'Сан-Марино',
    'ST': 'Сан-Томе и Принсипи',
    'SA': 'Саудовская Аравия',
    'SZ': 'Свазиленд',
    'SJ': 'Свальбард и Ян-Майен',
    'MP': 'Северные Марианские Острова',
    'SC': 'Сейшельские Острова',
    'PM': 'Сен-Пьер и Микелон',
    'SN': 'Сенегал',
    'VC': 'Сент-Винсент и Гренадины',
    'KN': 'Сент-Киттс и Невис',
    'LC': 'Сент-Люсия',
    'RS': 'Сербия',
    'CS': 'Сербия и Черногория',
    'SG': 'Сингапур',
    'SY': 'Сирийская Арабская Республика',
    'SK': 'Словакия',
    'SI': 'Словения',
    'SB': 'Соломоновы Острова',
    'SO': 'Сомали',
    'SU': 'Союз Советских Социалистических Республик',
    'SD': 'Судан',
    'SR': 'Суринам',
    'SL': 'Сьерра-Леоне',
    'TJ': 'Таджикистан',
    'TH': 'Таиланд',
    'TW': 'Тайвань',
    'TZ': 'Танзания',
    'TG': 'Того',
    'TK': 'Токелау',
    'TO': 'Тонга',
    'TT': 'Тринидад и Тобаго',
    'TV': 'Тувалу',
    'TN': 'Тунис',
    'TM': 'Туркменистан',
    'TR': 'Турция',
    'UG': 'Уганда',
    'UZ': 'Узбекистан',
    'WF': 'Уоллис и Футуна',
    'UY': 'Уругвай',
    'FO': 'Фарерские острова',
    'FM': 'Федеративные Штаты Микронезии',
    'FJ': 'Фиджи',
    'PH': 'Филиппины',
    'FI': 'Финляндия',
    'FK': 'Фолклендские острова',
    'FR': 'Франция',
    'GF': 'Французская Гвиана',
    'PF': 'Французская Полинезия',
    'TF': 'Французские Южные Территории',
    'FQ': 'Французские Южные и Антарктические территории',
    'HR': 'Хорватия',
    'CF': 'Центрально-Африканская Республика',
    'TD': 'Чад',
    'ME': 'Черногория',
    'CZ': 'Чешская республика',
    'CL': 'Чили',
    'CH': 'Швейцария',
    'SE': 'Швеция',
    'LK': 'Шри-Ланка',
    'EC': 'Эквадор',
    'GQ': 'Экваториальная Гвинея',
    'ER': 'Эритрея',
    'EE': 'Эстония',
    'ET': 'Эфиопия',
    'ZA': 'Южная Африка',
    'GS': 'Южная Джорджия и Южные Сандвичевы Острова',
    'JM': 'Ямайка',
    'JP': 'Япония'
  }

  return !code ? country : country[code]
}

export { convertYMDtoDMY, convertCountryCodeToCountry, convertDMYtoYMD }
